import { useEffect } from 'react';

/**
 * Запрещает прокрутку страницы, пока открыт слой.
 *
 * На мобильных это обязательно: без блокировки палец прокручивает страницу
 * партнёра под нашей корзиной, и пользователь теряет контекст.
 */
export function useScrollLock(isActive = true): void {
  useEffect(() => {
    if (!isActive) return;

    const { body } = document;

    // Если странице и так некуда прокручиваться, не трогаем её вовсе.
    //
    // Так оно и есть в обоих наших случаях: модуль на чужом сайте живёт
    // в кадре заданной высоты, а мини-приложение само запрещает прокрутку
    // страницы. Прежний код всё равно менял `overflow` и дописывал
    // `padding-right` под полосу прокрутки — и вёрстка дёргалась вбок
    // на каждом открытии окна, хотя прокручивать было нечего.
    const scrollbar = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbar <= 0 && body.scrollHeight <= window.innerHeight) return;

    const previousOverflow = body.style.overflow;
    const previousPaddingRight = body.style.paddingRight;

    if (scrollbar > 0) body.style.paddingRight = `${scrollbar}px`;
    body.style.overflow = 'hidden';

    return () => {
      body.style.overflow = previousOverflow;
      body.style.paddingRight = previousPaddingRight;
    };
  }, [isActive]);
}
